import {
    FORM_1099_BOX_GROUPS,
    Form1099Box,
    isAccountEligibleForForm1099Box,
    isForm1099Box,
} from "@common/constants/domains/accounting/form1099Box";
import { ExtendedAccount } from "@common/types/reports/types";
import type { PickerItemData } from "@design-system/Picker/Picker.types";

const NO_FORM_1099_BOX = "none";

export const FORM_1099_BOX_PICKER_ITEMS: Array<PickerItemData<string>> = [
    { value: NO_FORM_1099_BOX, label: "None" },
    ...FORM_1099_BOX_GROUPS.map((group) => ({
        value: group.form,
        label: group.form,
        children: group.options.map((option) => ({
            value: option.value,
            label: option.boxNumber,
            labelHint: option.boxDescription,
        })),
    })),
];

// undefined = a group header or unknown value (ignore), null = clear the box.
export const toForm1099Box = (
    value: string | null,
): Form1099Box | null | undefined => {
    if (value === null || value === NO_FORM_1099_BOX) {
        return null;
    }
    return isForm1099Box(value) ? value : undefined;
};

interface GetForm1099BoxUpdateTargetsParams {
    account: ExtendedAccount;
    similarAccounts: ExtendedAccount[];
    nextBox: Form1099Box | null;
}

export function getForm1099BoxUpdateTargets({
    account,
    similarAccounts,
    nextBox,
}: GetForm1099BoxUpdateTargetsParams): ExtendedAccount[] {
    const rowAccounts =
        similarAccounts.length > 0 ? similarAccounts : [account];
    return rowAccounts.filter(
        (rowAccount) =>
            isAccountEligibleForForm1099Box(rowAccount) &&
            (rowAccount.form1099Box ?? null) !== nextBox,
    );
}
